import React from 'react';
const testimonials = [{
  text: 'In soli 10 giorni la mia pancia è tornata piatta. Le ricette sono deliziose e finalmente ho smesso di sentirmi gonfia dopo pranzo.',
  author: 'Elena R. (Roma)'
}, {
  text: 'Il Meal Prep mediterraneo ha cambiato le mie domeniche. Lavoro 10 ore al giorno e ora so sempre cosa mangiare senza stress.',
  author: 'Marco T. (Milano)'
}, {
  text: 'Non è una dieta, è un nuovo modo di vivere. Mi sento sgonfia e piena di energia dopo anni di tentativi falliti.',
  author: 'Chiara G. (Bari)'
}];
export function Testimonials() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-sage-light" data-id="element-147">
      <div className="max-w-xl mx-auto" data-id="element-148">
        <div className="text-center mb-5 sm:mb-8" data-id="element-149">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main mb-3 sm:mb-4" data-id="element-150">
            💬 COSA DICE CHI HA GIÀ RESETTATO LA SUA VITA
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-151">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-sage/30 p-5 sm:p-6 rounded-xl" data-id="element-152">
              <p className="text-brand-text-main font-medium mb-3 sm:mb-4 text-sm sm:text-base leading-snug" data-id="element-153">
                "{t.text}"
              </p>
              <div className="border-t border-brand-sage/10 pt-3" data-id="element-154">
                <span className="text-xs sm:text-sm text-brand-text-muted font-bold" data-id="element-155">
                  — {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}